import React, { Component } from 'react'
import { Container } from 'components/Layout'
import Button from 'components/Button'
import cn from 'classnames'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import s from './CasesViewModal.scss'
import { moment } from 'features/Moment'
import { Form, Field } from 'redux-form'
import { Textarea } from 'components/Input/Textarea'
import { vRequired } from 'components/Input/Input.validations'
import LoadingOverlay from 'components/Loading/LoadingOverlay'

const tableContent = {
  'Trouble Ticket': [
    ['Case Number:', 'caseId'],
    ['Case Title:', 'subject'],
    ['Status:', 'status'],
    ['Service Number:', 'service'],
    ['Service Type:', 'productLine'],
    ['Fault Symptom:', 'symptom'],
  ],
  'Billing Enquiry': [
    ['Case Number:', 'caseId'],
    ['Case Title:', 'subject'],
    ['Status:', 'status'],
    ['Disputed Amount:', 'disputedAmount'],
    ['Findings:', 'findings'],
    ['Description:', 'description'],
  ],
  'Billing Dispute': [
    ['Case Number:', 'caseId'],
    ['Case Title:', 'subject'],
    ['Status:', 'status'],
    ['Disputed Amount:', 'disputedAmount'],
    ['Findings:', 'findings'],
    ['Description:', 'description'],
  ],
  'Product Order': [
    ['Case Number:', 'caseId'],
    ['Case Title:', 'subject'],
    ['Status:', 'status'],
    ['Order Submission Date:', 'orderSubmissionDate'],
    ['Planned Delivery Date:', 'plannedDeliveryDate'],
    ['Billing Start Date:', 'billingStartDate'],
  ],
}

export default class CasesViewModal extends Component {
  componentWillMount() {
    const { caseItem, getTroubleTicket } = this.props
    if (caseItem.recordType === 'Trouble Ticket' && caseItem.frontierLinkCase) {
      getTroubleTicket(caseItem.id)
    }
  }
  render() {
    const {
      modalCancel,
      caseItem,
      submitting,
      addTroubleTicketNote,
      handleSubmit,
      reset,
    } = this.props
    const table = tableContent[caseItem.recordType] || tableContent['Trouble Ticket']

    return (
      <Container paddingTop paddingBottom className="sm">
        <div style={{ margin: '0 30px' }}>
          <div className={cn(sText.descrip2, sText.center)}>Case Details:</div>
          <br />
          <br />
          <div>
            {table.map(
              (item, key) =>
                caseItem[item[1]] && (
                  <div key={key} style={{ marginBottom: '15px' }}>
                    <div style={{ marginBottom: '5px', opacity: '0.8' }}>{item[0]}</div>
                    <div>{caseItem[item[1]]}</div>
                  </div>
                )
            )}
            <br />
          </div>
          <div>
            {caseItem.troubleTicket &&
              caseItem.troubleTicket.history &&
              caseItem.troubleTicket.history.map((item, idx) => (
                <div key={idx} className={s.historyItem}>
                  <div className={s.time}>{moment(item.time).format('DD MMM YYYY, h:mm:ss a')}</div>
                  {item.text}
                </div>
              ))}
          </div>
          {caseItem.recordType === 'Trouble Ticket' &&
            caseItem.frontierLinkCase &&
            !caseItem.troubleTicket && <LoadingOverlay />}
          {caseItem.troubleTicket && (
            <Form onSubmit={handleSubmit(data => addTroubleTicketNote(data).then(() => reset()))}>
              <Field
                name="note"
                label="Note"
                display="standard"
                component={Textarea}
                validate={[vRequired]}
              />
              <div
                className={cn(sLay['layout-column'], sLay['layout-align-center-center'])}
                style={{ marginTop: '40px' }}
              >
                <Button color="tertiary" loading={submitting} type="submit">
                  Add note
                </Button>
                <br />
                <br />
                <Button plain onClick={modalCancel}>
                  Close
                </Button>
              </div>
            </Form>
          )}
        </div>
      </Container>
    )
  }
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cases/CasesViewModal/CasesViewModal.jsx